import { Controller } from '@hotwired/stimulus'
import Cookies from 'js-cookie'

export default class extends Controller {
  connect () {
    if (this.modalId() === Cookies.get('verified_modal_id')) {
      this.disableMyFacilitiesModal()
      this.disableInquiryModal()
    }

    this.saveFacilityViewed(this.facilityId())
  }

  saveFacilityViewed (id) {
    const TTL = 90 * 24 * 60 * 60 * 1000 // 90 days
    const now = Date.now()
    let data = {}
    try { data = JSON.parse(localStorage.getItem('cs.readFacilities') || '{}') } catch (e) {}
    data[id] = now
    for (const k in data) if (now - data[k] > TTL) delete data[k]
    try { localStorage.setItem('cs.readFacilities', JSON.stringify(data)) } catch (e) {}
  }

  facilityId () {
    return this.element.dataset.facilityid
  }

  modalId () {
    return this.element.dataset.modalid
  }

  controllerForAdding () {
    return this.element.dataset.controllerforadding
  }

  controllerForUpdating () {
    return this.element.dataset.controllerforupdating
  }

  disableMyFacilitiesModal () {
    this.element.querySelectorAll('.myfacilities-with-modal').forEach((element) => {
      element.dataset.action = `click->${this.controllerForAdding()}#add click->${this.controllerForUpdating()}#update`
    })
  }

  disableInquiryModal () {
    this.element.querySelectorAll('.inquiry-with-modal').forEach((element) => {
      element.dataset.action = ''
    })
  }
}
